import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

const QuantityControl = ({ initialQuantity = 1, onQuantityChange }) => {
    const [quantity, setQuantity] = useState(initialQuantity);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setQuantity(initialQuantity);
    }, [initialQuantity]);

    const handleQuantityChange = async (newQuantity) => {
        if (newQuantity >= 1) {
            if(onQuantityChange) {
                setLoading(true);
                try {
                    const r = await onQuantityChange(newQuantity);
                    if(r) {
                        setQuantity(newQuantity);
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                setQuantity(newQuantity);
            }
        }
    };

    const incrementQuantity = () => handleQuantityChange(quantity + 1);
    const decrementQuantity = () => handleQuantityChange(quantity - 1);

    return (
        <div className="overflow-hidden d-flex rounded-4">
            <button
                type="button"
                onClick={decrementQuantity}
                className="flex-shrink-0 w-48 h-48 border border-gray-100 quantity__minus border-end text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
                disabled={quantity <= 1 || loading}
            >
                {loading ? <LoadingSpinner width={14} height={14} /> : <i className="ph ph-minus" />}
            </button>
            <input
                type="number"
                className="w-32 px-4 text-center border border-gray-100 quantity__input flex-grow-1 border-start-0 border-end-0"
                value={quantity}
                min={1}
                readOnly
            />
            <button
                type="button"
                onClick={incrementQuantity}
                className="flex-shrink-0 w-48 h-48 border border-gray-100 quantity__plus border-end text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
                disabled={loading}
            >
                {loading ? <LoadingSpinner width={14} height={14} /> : <i className="ph ph-plus" />}
            </button>
        </div>
    );
};

export default QuantityControl;
